export const VENDOR_REVIEW_TABS = {
  VENDOR_INFO: 'vendor-info',
  STORE_ITEMS: 'store-items'
};
